import React from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton, Button, Container } from '@mui/material';
import { ShoppingBagOutlined } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const Navbar = () => {
    return (
        <AppBar
            position="sticky"
            elevation={0}
            sx={{
                backgroundColor: 'rgba(247, 244, 239, 0.90)',
                backdropFilter: 'blur(10px)',
                borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
                color: '#1a1a1a'
            }}
        >
            <Container maxWidth="xl">
                <Toolbar disableGutters sx={{ justifyContent: 'space-between', py: 2.5 }}>
                    {/* Brand */}
                    <Box component={Link} to="/" sx={{ textDecoration: 'none', color: 'inherit' }}>
                        <Typography
                            variant="h2"
                            sx={{
                                fontFamily: "'Cormorant Garamond', serif",
                                fontWeight: 800,
                                fontSize: '2.8rem',
                                letterSpacing: '-0.01em',
                                display: 'inline-block',
                                lineHeight: 1
                            }}
                        >
                            WillowStyle.Store
                        </Typography>
                    </Box>

                    {/* Links */}
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 4 }}>
                        {['Home', 'Shop', 'About', 'Contact', 'Policies'].map((text) => (
                            <Button
                                key={text}
                                component={Link}
                                to={text === 'Home' ? '/' : `/${text.toLowerCase()}`}
                                sx={{
                                    fontFamily: "'Sora', sans-serif",
                                    fontSize: '0.95rem',
                                    fontWeight: 500,
                                    color: '#333',
                                    textTransform: 'none',
                                    opacity: 0.8,
                                    '&:hover': { opacity: 1, backgroundColor: 'transparent' }
                                }}
                            >
                                {text}
                            </Button>
                        ))}
                    </Box>

                    {/* Actions */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton color="inherit">
                            <ShoppingBagOutlined sx={{ fontSize: '1.5rem' }} />
                        </IconButton>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Navbar;
